/**
 * ------------------------------------------------------------
 * TOTAL gallons used
 * ------------------------------------------------------------
 */
export function computeTotalGalsUsed(navlogLegsComputed) {
  return navlogLegsComputed.reduce((sum, row) => {
    const g = Number(row.galsUsed);

    return Number.isFinite(g)
      ? sum + g
      : sum;
  }, 0);
}

/**
 * ------------------------------------------------------------
 * TOTAL ETE (minutes)
 * ------------------------------------------------------------
 */
export function computeTotalEteMin(navlogLegsComputed) {
  return navlogLegsComputed.reduce((sum, row) => {
    const t = Number(row.eteMin);

    return Number.isFinite(t)
      ? sum + t
      : sum;
  }, 0);
}

/**
 * ------------------------------------------------------------
 * FORMAT minutes as H:MM
 * ------------------------------------------------------------
 */
export function formatTime(minutes) {
  if (!Number.isFinite(minutes)) return "";

  const hrs = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);

  return `${hrs}:${String(mins).padStart(2, "0")}`;
}

/**
 * ------------------------------------------------------------
 * TOTAL DISTANCE (NM)
 * ------------------------------------------------------------
 */
export function computeTotalDistance(navlogLegsComputed) {
  return navlogLegsComputed.reduce((sum, row) => {
    const nm = Number(row.nm);

    return sum + (
      Number.isFinite(nm)
        ? nm
        : 0
    );
  }, 0);
}

/**
 * ------------------------------------------------------------
 * FUEL REMAINING
 * ------------------------------------------------------------
 */
export function computeFuelRemaining(
  startFuel,
  totalGalsUsed
) {
  const start = Number(startFuel);
  const used = Number(totalGalsUsed);

  if (
    !Number.isFinite(start) ||
    !Number.isFinite(used)
  ) {
    return "";
  }

  return start - used;
}

/**
 * ------------------------------------------------------------
 * PRESSURE ALTITUDE (PA)
 * Uses field elevation and altimeter
 * ------------------------------------------------------------
 */
export function computePressureAltitudeFt(
  departElevation,
  localAltimeter
) {
  const elev = Number(departElevation);
  const alt = Number(localAltimeter);

  if (
    !Number.isFinite(elev) ||
    !Number.isFinite(alt)
  ) {
    return "";
  }

  // PA = field elevation + (29.92 - altimeter) * 1000
  return elev + (29.92 - alt) * 1000;
}

/**
 * ------------------------------------------------------------
 * DENSITY ALTITUDE (DA)
 * Uses pressure altitude and OAT
 * ------------------------------------------------------------
 */
export function computeDensityAltitudeFt(
  pressureAltitudeFt,
  localOat
) {
  const pa = Number(pressureAltitudeFt);
  const oatC = Number(localOat);

  if (
    !Number.isFinite(pa) ||
    !Number.isFinite(oatC)
  ) {
    return "";
  }

  // ISA temperature at altitude
  const isaC = 15 - 2 * (pa / 1000);

  // DA approximation
  return pa + 120 * (oatC - isaC);
}

/**
 * ------------------------------------------------------------
 * FORMAT feet without decimals
 * ------------------------------------------------------------
 */
export function fmtFt0(v) {
  return Number.isFinite(Number(v))
    ? Math.round(Number(v)).toLocaleString()
    : "";
}